import { getLocale } from "../runtime";

const sv_untilfreeshipping = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `tills fri frakt`
};

const untilfreeshipping = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_untilfreeshipping(inputs)
	return "untilFreeShipping";
};

export { untilfreeshipping as "untilFreeShipping" };